import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import PromotionMainBlock from './PromotionMainBlock/PromotionMainBlock';
import { useSelector } from 'react-redux';
import { productTabName } from '../../../state/promotions';
import { useFetchMergedPromotions } from '../../../hooks/useFetchMergedPromotions';
import { PromotionsBlock } from './PromotionsBlock';

export const Promotions: FC = () => {
  const { id } = useParams();
  const currentProductTab = useSelector(productTabName);

  const { mergedFilteredPromotions, isPromosLoading, promotionsLoadingError } =
    useFetchMergedPromotions(currentProductTab);

  return id ? (
    <PromotionMainBlock />
  ) : (
    <PromotionsBlock
      promotionsFiltered={mergedFilteredPromotions}
      isPromosLoading={isPromosLoading}
      promotionsLoadingError={promotionsLoadingError}
    />
  );
};
